!function(){
  const t = {
    cfg: {
      dataAttrAppUrl: "data-brick-url",
      dataAttrCheckout: "brick-procceded",
      dataAttrCustomDomain: "data-checkout-domain",
      defaultAppBaseUrl: "",
      domainPath: "checkout"
    },
    vars: {
      checkoutDomain: null,
      isCheckoutProcessing: false
    },
    cartApi: {
      clearCart: function() {
        return fetch("/cart/clear.js", {
          method: "POST",
          credentials: "same-origin"
        });
      },
      addToCart: function(t) {
        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          body: "FORM" === t.nodeName ? new FormData(t) : t
        });
      }
    },
    helpers: {
      debounce: function(t, e) {
        let o = !1;
        return function() {
          o || (o = !0, setTimeout(() => {
            t.apply(this, arguments);
            o = !1;
          }, e));
        };
      },
      isChild: (t, e) => {
        let o = e.parentNode;
        for (; null !== o;) {
          if (o === t) return !0;
          o = o.parentNode;
        }
        return !1;
      },
      addWrapperListener: (e, o, r) => {
        e.addEventListener && window.addEventListener(o, (o) => {
          (o.target === e || t.helpers.isChild(e, o.target)) && (o.stopImmediatePropagation(), o.preventDefault(), r());
        }, !0);
      },
      // Новий helper - тільки для click
      addClickOnlyListener: (e, callback) => {
        if (e.addEventListener) {
          e.addEventListener("click", (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();
            callback();
          }, true);
        }
      },
      getCookie: t => {
        let e = document.cookie.match(new RegExp("(?:^|; )" + t.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return e ? decodeURIComponent(e[1]) : void 0;
      },
      setCookie: (t, e) => {
        let o = new Date(Date.now() + 18e5).toUTCString();
        document.cookie = `${t}=${e}; expires=` + o + ";path=/;";
      }
    },
    dom: {
      selectors: {
        checkoutForm: 'form[action^="/cart"]:not([action^="/cart/"]), form[action="/checkout"], form[action="/a/checkout"]',
        checkoutButton: '[name="checkout"],[name="Checkout"],[class*="opcCheckout"],[class*="checkout-btn"],[class*="btn-checkout"],[class*="checkout-button"],[class*="button-checkout"],[class*="carthook_checkout"],[type*="submit"][class*="action_button"]:not([name*="add"]),[href*="/checkout"][class*="action_button"],[id*="checkout"],[id*="Checkout"],[id*="checkout-button"],[id*="checkout-btn"]',
        directCheckoutLink: 'a[href^="/checkout"],[onclick*="/checkout"],a[href*="/checkout"]',
        addToCartForm: 'form[action^="/cart/add"]',
        returnToField: 'input[name="return_to"][value*="checkout"]',
        buyNowForm: 'form[action^="/cart/add"][data-skip-cart="true"]',
        checkoutUpdateButton: '[type="submit"][name="update"]',
        dynamicPaymentButton: '[data-shopify="payment-button"] button,[data-shopify="payment-button"] .shopify-payment-button__button',
        dynamicPaymentButtonContainer: '[data-shopify="payment-button"]'
      },
      getCheckoutForms: () => document.querySelectorAll(t.dom.selectors.checkoutForm),
      getCheckoutButtons: () => document.querySelectorAll(t.dom.selectors.checkoutButton),
      getCheckoutLinks: () => document.querySelectorAll(t.dom.selectors.directCheckoutLink),
      getBuyItNowForms: () => {
        const e = [...document.querySelectorAll(t.dom.selectors.buyNowForm)];
        document.querySelectorAll(t.dom.selectors.returnToField).forEach((t) => {
          const o = t.closest("form");
          o && e.filter((t) => o.isSameNode(t)).length <= 0 && e.push(o);
        });
        return e;
      },
      getAddToCartForm: () => document.querySelector(t.dom.selectors.addToCartForm),
      getDynamicPaymentButtons: () => document.querySelectorAll(t.dom.selectors.dynamicPaymentButton),
      getUpdateCartButtons: () => document.querySelectorAll(t.dom.selectors.checkoutUpdateButton),
      getDynamicPaymentButtonContainer: () => document.querySelector(t.dom.selectors.dynamicPaymentButtonContainer)
    },
    functions: {
      getAppBaseUrl: () => {
        const e = document.querySelector("[" + t.cfg.dataAttrAppUrl + "]"),
              o = e.getAttribute(t.cfg.dataAttrCustomDomain),
              r = e.getAttribute(t.cfg.dataAttrAppUrl),
              n = t.cfg.defaultAppBaseUrl;
        return o || (r || n);
      },
      getOriginUrl: () => window.location.origin,
      getCartToken: () => t.helpers.getCookie("cart"),
      getStoreName: () => window.Shopify && window.Shopify.shop ? window.Shopify.shop : "",
      getStoreActieCurrency: () => window.Shopify.currency.active,
      getStoreCountry: () => window.Shopify.country,
      getStoreActiveCurrencyRate: () => window.Shopify.currency.rate,
      getStoreRootRoute: () => window.Shopify.routes.root,
      submitBuyNowForm: e => {
        let o = e.closest("form");
        if (o || (o = t.dom.getAddToCartForm()), o) {
          if (!o.querySelector('[name="quantity"]')) {
            const t = document.createElement("input");
            t.setAttribute("type", "hidden");
            t.setAttribute("name", "quantity");
            t.setAttribute("value", "1");
            o.appendChild(t);
          }
          if (!o.querySelector('input[name="return_to"]')) {
            const t = document.createElement("input");
            t.setAttribute("type", "hidden");
            t.setAttribute("name", "return_to");
            t.setAttribute("value", "/checkout");
            o.appendChild(t);
          }
          t.cartApi.clearCart().then(() => t.cartApi.addToCart(o)).then(() => t.functions.processCheckout());
        }
      },
      processCheckout: () => {
        if (!t.vars.isCheckoutProcessing) {
          t.vars.isCheckoutProcessing = !0;
          const e = t.functions.getAppBaseUrl(),
                o = t.functions.getCartToken(),
                r = t.functions.getOriginUrl().replace(/^https?:\/\//, ""),
                n = t.functions.getStoreRootRoute(),
                c = t.functions.getStoreName(),
                a = t.functions.getStoreActiveCurrencyRate(),
                u = t.helpers.getCookie("_shopify_sa_p"),
                // Промокод з /discount/<CODE>-лінків (листи): Shopify кладе його
                // в cookie discount_code на домені магазину, а платіжка живе на
                // іншому домені — передаємо через URL.
                g = t.helpers.getCookie("discount_code"),
                // Meta Pixel: куки _fbp/_fbc не переносяться на домен платіжки —
                // передаємо через URL, платіжка перезапише їх у свої куки, і її
                // піксель зможе зматчити InitiateCheckout/Purchase з кліком по
                // рекламі. Свіжий fbclid з URL має пріоритет над кукою (кука може
                // бути від старішого кліку).
                fbp = t.helpers.getCookie("_fbp"),
                fbclidParam = new URLSearchParams(window.location.search).get("fbclid"),
                fbc = fbclidParam ? "fb.1." + Date.now() + "." + fbclidParam : (t.helpers.getCookie("_fbc") || "");
          let i = new URLSearchParams(window.location.search),
              s = i.get("utm_campaign"),
              d = i.get("utm_medium"),
              m = i.get("utm_source"),
              l = i.get("utm_content"),
              h = i.get("utm_term");
          const p = `${s ? `&utm_campaign=${s}` : ""}${d ? `&utm_medium=${d}` : ""}${m ? `&utm_source=${m}` : ""}${l ? `&utm_content=${l}` : ""}${h ? `&utm_term=${h}` : ""}`;
          if (e && o && r) {
            let t = !1;
            const i = `${e}/checkout/?storeName=${r}&cartToken=${o}&curRate=${a}&shopifyDomain=${c}${n.length > 2 ? "&subFolder=" + n.replace(/\//g, "") : ""}${g ? "&promo=" + encodeURIComponent(g) : ""}${fbp ? "&fbp=" + encodeURIComponent(fbp) : ""}${fbc ? "&fbc=" + encodeURIComponent(fbc) : ""}`;
            window.ga && ga((e) => {
              var o = e.get("linkerParam");
              window.location = `${i}&${o}${u ? `&${u}` : p ? `${p}` : ""}`;
              t = !0;
            });
            t || (window.location = `${i}${u ? `&${u}` : p ? `${p}` : ""}`);
          } else {
            window.location = "/checkout";
          }
        }
      },
      addHandlers: () => {
        const e = t.dom.getCheckoutForms(),
              o = t.dom.getCheckoutLinks(),
              r = t.dom.getCheckoutButtons(),
              n = t.dom.getBuyItNowForms(),
              c = t.dom.getUpdateCartButtons();
        
        // Форми checkout - submit
        [...e].forEach((e) => {
          if ("true" !== e.getAttribute(t.cfg.dataAttrCheckout)) {
            t.helpers.addWrapperListener(e, "submit", () => {
              t.functions.processCheckout();
            });
            e.setAttribute(t.cfg.dataAttrCheckout, "true");
          }
        });
        
        // Кнопки та посилання checkout - ТІЛЬКИ click (виправлено!)
        [...o, ...r].forEach((e) => {
          if ("true" !== e.getAttribute(t.cfg.dataAttrCheckout)) {
            t.helpers.addClickOnlyListener(e, () => {
              t.functions.processCheckout();
            });
            e.setAttribute(t.cfg.dataAttrCheckout, "true");
          }
        });
        
        // Buy Now форми - submit
        [...n].forEach((e) => {
          if ("true" !== e.getAttribute(t.cfg.dataAttrCheckout)) {
            t.helpers.addWrapperListener(e, "submit", () => {
              t.functions.submitBuyNowForm(e);
            });
            e.setAttribute(t.cfg.dataAttrCheckout, "true");
          }
        });
        
        // Update кнопки - click
        [...c].forEach((e) => {
          if ("true" !== e.getAttribute(t.cfg.dataAttrCheckout)) {
            t.helpers.addWrapperListener(e, "click", () => {
              e.closest("form").submit();
            });
            e.setAttribute(t.cfg.dataAttrCheckout, "true");
          }
        });
      },
      addDynamicButtonHandlers: () => {
        [...t.dom.getDynamicPaymentButtons()].forEach((e) => {
          // Dynamic payment buttons - ТІЛЬКИ click (виправлено!)
          t.helpers.addClickOnlyListener(e, () => {
            t.functions.submitBuyNowForm(e);
          });
        });
      },
      // Пиксель Shopify живе в sandbox web pixels і НЕ пише _fbp/_fbc на домен
      // вітрини — тому fbclid з рекламного кліка треба зберегти самим, інакше
      // він губиться при переході з лендінга в /cart і до платіжки не доїде.
      // Формат fb.1.<ts>.<fbclid> і кука _fbc — стандарт Meta, 90 днів.
      // Новий fbclid ЗАВЖДИ перезаписує стару куку (як робить сам піксель Meta):
      // інакше після повторного кліку по рекламі в CAPI їде старий fbc зі
      // старим timestamp → діагностика «просрочений fbclid у fbc».
      captureFbclid: () => {
        try {
          const e = new URLSearchParams(window.location.search).get("fbclid");
          if (!e) return;
          const cur = t.helpers.getCookie("_fbc") || "";
          if (cur.split(".").slice(3).join(".") === e) return;
          document.cookie = "_fbc=" + encodeURIComponent("fb.1." + Date.now() + "." + e) + ";path=/;max-age=" + 90 * 24 * 3600 + ";SameSite=Lax";
        } catch (e) {}
      },
      init: () => {
        if ("UA" === t.functions.getStoreCountry()) {
          t.functions.captureFbclid();
          t.functions.addDynamicButtonHandlers();
          t.functions.addHandlers();
          
          document.addEventListener("DOMContentLoaded", () => {
            t.functions.addDynamicButtonHandlers();
            t.functions.addHandlers();
          });
          
          window.addEventListener("load", () => {
            t.functions.addDynamicButtonHandlers();
            t.functions.addHandlers();
            
            const e = t.helpers.debounce(() => {
              t.functions.addHandlers();
              t.functions.addDynamicButtonHandlers();
            }, 100);
            
            new MutationObserver(() => {
              e();
            }).observe(window.document, {
              attributes: !0,
              childList: !0,
              subtree: !0
            });
          });
        }
      }
    }
  };
  
  t.functions.init();
}();